export default class PathwayMicroducts{
  constructor(api) {
    this.api = api;
  }

  getPathwayDuctConfiguration(pathwayUUID, onSuccess, onError) {
    return this.api.http_fibercloud
      .get("v1/pathways/" + pathwayUUID + '/ductconfiguration')
      .then(resp => {
        onSuccess(resp);
      })
      .catch(error => {
        onError(error);
      });
  }
}


// WEBPACK FOOTER //
// ./src/api/pathwayMicroducts.js